import { CommonModule } from "@angular/common";
import { Component, Input, SimpleChanges } from "@angular/core";
import { Subscription } from "rxjs";
import { ModalService } from "../../services/modal/modal.service";
import { ReactiveFormsModule } from "@angular/forms";
import moment from "moment";
import { InfoPopoverComponent } from "../../dashboard/utils/info-popover/info-popover.component";
import { GraphPopoverInstructionComponent } from "../../dashboard/utils/graph-popover-instruction/graph-popover-instruction.component";

@Component({
  selector: "app-field-view-entity",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InfoPopoverComponent,
    GraphPopoverInstructionComponent,
  ],
  templateUrl: "./field-view-entity.component.html",
  styleUrl: "./field-view-entity.component.scss",
})
export class FieldViewEntityComponent {
  // Define the constructor, including modalService
  constructor(private modalService: ModalService) {}
  visible = false; // Control the visibility of the modal
  private modalSubscription: Subscription | undefined; // Define the subscription, monitor the change of fieldViewManager
  private isInitialized = false; // Define the isInitialized variable
  // Two inputs, id and properties
  @Input() id!: number;
  @Input() properties!: any;
  // List Values rendered in the View Modal
  userName?: string;
  email?: string;
  fieldName?: string;
  totalTargetWater?: string;
  crop_type_01?: string;
  ls_start_01?: string;
  ls_end_01?: string;
  irrigation_methods_01?: string[];
  crop_type_02?: string;
  ls_start_02?: string;
  ls_end_02?: string;
  irrigation_methods_02?: string[];
  crop_type_03?: string;
  ls_start_03?: string;
  ls_end_03?: string;
  irrigation_methods_03?: string[];
  is_deficit_irrigation?: string;

  readonly irrigationDropdownLabel = "Primary Irrigation Method";

  // ngOnInit Hook
  ngOnInit() {
    // Add Subscription of the Modal
    this.modalSubscription =
      this.modalService.fieldViewEntitySubject$.subscribe((visible) => {
        this.visible = visible;
      });
  }

  // ngOnChanges hook
  async ngOnChanges(changes: SimpleChanges) {
    if (!this.isInitialized) {
      this.isInitialized = true;
    } else {
      this.fieldName = this.properties.field_name;
      this.userName =
        this.properties.username ||
        [this.properties.first_name, this.properties.last_name]
          .filter((n: string) => !!n)
          .join(" ");
      this.email = this.properties.email;
      this.totalTargetWater =
        this.properties.total_target_water +
        " (" +
        this.properties.total_target_type +
        ") " +
        this.properties.total_target_water_unit;
      // Deficit Irrigation
      this.is_deficit_irrigation =
        this.properties.is_deficit_irrigation === true ? "Yes"
        : this.properties.is_deficit_irrigation === false ? "No"
        : "";
      // Crop Group 01
      this.crop_type_01 = this.properties.crop_type_01;
      this.irrigation_methods_01 = this.properties.irrigation_methods_01[0];
      // this.ls_start_01 = moment(this.properties.ls_start_01).format('YYYY-MM-DD');
      // this.ls_end_01 = moment(this.properties.ls_end_01).format('YYYY-MM-DD');
      this.ls_start_01 = moment(this.properties.ls_start_01)
        .utc()
        .format("YYYY-MM-DD");
      this.ls_end_01 = moment(this.properties.ls_end_01)
        .utc()
        .format("YYYY-MM-DD");
      // Crop Group 02
      this.crop_type_02 =
        this.properties.crop_type_02 ? this.properties.crop_type_02 : "No Crop";
      this.irrigation_methods_02 =
        this.properties.irrigation_methods_02 ?
          this.properties.irrigation_methods_02[0]
        : "None";
      this.ls_start_02 =
        this.properties.ls_start_02 ?
          moment(this.properties.ls_start_02).utc().format("YYYY-MM-DD")
        : "None";
      this.ls_end_02 =
        this.properties.ls_end_02 ?
          moment(this.properties.ls_end_02).utc().format("YYYY-MM-DD")
        : "None";
      // Crop Group 03
      this.crop_type_03 =
        this.properties.crop_type_03 ? this.properties.crop_type_03 : "No Crop";
      this.irrigation_methods_03 =
        this.properties.irrigation_methods_03 ?
          this.properties.irrigation_methods_03[0]
        : "None";
      this.ls_start_03 =
        this.properties.ls_start_03 ?
          moment(this.properties.ls_start_03).utc().format("YYYY-MM-DD")
        : "None";
      this.ls_end_03 =
        this.properties.ls_end_03 ?
          moment(this.properties.ls_end_03).utc().format("YYYY-MM-DD")
        : "None";

      // After Initializing, when new data of id and properties comming, toogle the FieldViewManagerModal.
      this.modalService.toggleFieldViewEntityModal();
    }
  }

  // Function to close the Modal
  closeModal(): void {
    this.modalService.toggleFieldViewEntityModal();
  }

  // ngOnDestroy Hook, unsubscribe the modalSubscription when the component is destroyed.
  ngOnDestroy() {
    if (this.modalSubscription) {
      this.modalSubscription.unsubscribe();
    }
  }
}
